import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { SearchtoolboxService } from 'src/app/_services/searchtoolbox.service';
import { TalentpoolService } from 'src/app/_services/talentpool.service';
import { TransactionService } from 'src/app/_services/transaction.service';
import { CreateTalentpoolComponent } from 'src/app/talentpool/create-talentpool/create-talentpool.component';
declare const clevertap;

@Component({
  selector: 'app-talentpool-history',
  templateUrl: './talentpool-history.component.html',
  styleUrls: ['./talentpool-history.component.scss']
})
export class TalentpoolHistoryComponent implements OnInit {
  talentpools : any
  successMessage: string;
  errorMessage: string;
  subscriptiondetails: any = {}
  @ViewChild('noCreditTalentpool') noCreditTalentpool: TemplateRef<any>;
  isteamMember: boolean;
  @Output() viewAllUpdate :  EventEmitter<any> = new EventEmitter();

  constructor(private router : Router , public talentpoolservice : TalentpoolService ,private _localstorageservice : LocalStorageService, public searchtoolservice: SearchtoolboxService, 
    private modalService: NgbModal,private transactionservice:TransactionService) { }

  ngOnInit(): void {
    this.getTalentpoolList()
  }
  getTalentpoolList(){
    this.talentpoolservice.getTalentpoolList(this._localstorageservice.getItem('usernumber'), 'updatedondesc').subscribe((res:any)=>{
      if(res.status =="success"){
        this.talentpools = res.data.talentpools 
        this.viewAllUpdate.emit(this.talentpools)
      }
    })

  }
  createTalentpool() {
    if(this._localstorageservice.getItem('tpcredits') > 0){
      const modalRef = this.modalService.open(CreateTalentpoolComponent, { size: 'lg' as 'lg', backdrop: 'static', keyboard: false ,centered: true,});
      modalRef.componentInstance.passEntry.subscribe((x) => {
        if (x == 'talentpool-added') {
          this.toastmessage('Talentpool Created Succesfully', 'success')
          this.fetchcredits()
          this.getTalentpoolList()
      }else if(x == 'notpcredits'){
        const modalRef = this.modalService.open(this.noCreditTalentpool,{ windowClass: "myCustomModalClass", centered: true });
        this.sendmailexpiry('Talent Pipeline credits')
      }
      else if(x =='error'){
        this.toastmessage('Something went wrong, Please try again in a minute', 'error')
      }})
      }else{
        let clevertap_data = {
          "Talent Pool Name" : 'null',
        }
        this.cleverTapEvent("TalentPool_CreditExpiry", clevertap_data);
        const modalRef = this.modalService.open(this.noCreditTalentpool,{ windowClass: "myCustomModalClass", centered: true });
        this.sendmailexpiry('Talent Pipeline credits')
      }
  }


  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }
  fetchcredits(){
    this.transactionservice.fetchcurrentplandetails(this._localstorageservice.getItem('usernumber')).subscribe((res:any)=>{
      if(res.status == 'success'){
        if (res.data.isteamadmin) {
          // Here the logged in person is a Team Admin
          this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
          this.subscriptiondetails.balancejdparsingcredits = res.data.pooledbalancejdparsingcredits;
          this.subscriptiondetails.balancesmartemailcredits = res.data.pooledbalancesmartemailcredits;
          this.subscriptiondetails.balancetalentpipelinecredits = res.data.pooledbalancetalentpipelinecredits;
        } else {
          if (res.data.teamadmindetails) {
            // Here the logged in person is a Team Member
            this.isteamMember = true
            this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
            this.subscriptiondetails.balancejdparsingcredits = res.data.teamadmindetails.adminbalancejdparsingcredits;
            this.subscriptiondetails.balancesmartemailcredits = res.data.teamadmindetails.adminbalancesmartemailcredits;
            this.subscriptiondetails.balancetalentpipelinecredits = res.data.teamadmindetails.adminbalancetalentpipelinecredits;
          } else {
            // Here the logged in person is a normal (who does not belong to any team)
            this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
            this.subscriptiondetails.balancejdparsingcredits = res.data.balancejdparsingcredits;
            this.subscriptiondetails.balancesmartemailcredits = res.data.balancesmartemailcredits;
            this.subscriptiondetails.balancetalentpipelinecredits = res.data.balancetalentpipelinecredits;
          }
        }
        this._localstorageservice.setItem('jdcredits', this.subscriptiondetails.balancejdparsingcredits)
        this._localstorageservice.setItem('tpcredits', this.subscriptiondetails.balancetalentpipelinecredits)
        this._localstorageservice.setItem('cecredits', this.subscriptiondetails.balancecontactenrichmentcredits)
        this._localstorageservice.setItem('secredits', this.subscriptiondetails.balancesmartemailcredits)
      }
    })
  }
  sendmailexpiry(type){
    let data ={
      expiredmetric : type
    }
    this.transactionservice.sendcreditexpirymail(data).subscribe()
  }
  cleverTapEvent(eventName, data) {
    clevertap.event.push(eventName, data);
    console.log(eventName + " CT event");
  }
  OpenCandidateList(type){
    if(type == 'all'){
      this.router.navigateByUrl("/candidate-list")
    }
    else{
      let talentpoolid = type.talentpoolid
      this.router.navigate(['talentpool/details/'+ talentpoolid])
    }
  }
}
